import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import content from "../../content";

const Transition: any = React.forwardRef(function Transition(
  props: any,
  ref: any
): any {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialog({
                                      open,
                                      handleClose,
                                      action,
                                      title,
                                      label,
                                    }: IDialog) {
  const handleClick = () => {
    if (action) {
      action();
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      style={{
        zIndex: 40002
      }}
      TransitionComponent={Transition as any}
      keepMounted
      onClose={handleClose}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {label}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {content.getValue("notification_close")}
        </Button>
        <Button onClick={handleClick} color="primary">
          {content.getValue("notification_ok")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export interface IDialog {
  open: boolean;
  handleClose: () => void;
  action: () => void;
  title: string;
  label: string;
}
